import * as React from 'react'
import { ReactElement } from 'react'
import { LegalStructure } from '../../../config/i18nConfig'
import I18NCombobox, { I18NComboboxProps } from './I18NCombobox'
import useLegalStructures from '../../../hooks/useLegalStructures'

export type LegalStructureComboboxProps = Omit<I18NComboboxProps<LegalStructure>, 'entities' | 'idKey'>

export default function LegalStructureCombobox(props: LegalStructureComboboxProps): ReactElement {
    const { legalStructures } = useLegalStructures()

    return (
        <I18NCombobox<LegalStructure>
            entities={legalStructures}
            idKey={'alpha'}
            placeholderKey={'base.legalstructurecombobox.placeholder'}
            {...props}
        />
    )
}
